
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { blue} from '@material-ui/core/colors';

const BlueButton = withStyles(theme => ({
    root: {
        textTransform: 'none',
    fontSize: 14,
    padding: '6px 12px',
      color: theme.palette.getContrastText(blue[500]),
      backgroundColor: blue[500],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
  }))(Button);

  export default BlueButton;